import React, { useEffect, useState } from "react"
import { CardTitle, Container } from "reactstrap"
import PhoneVerification from "./phoneVerification"
import IDVerification from "./IDVerification"
import BankDetails from "./bankDetails"
import AdditionalDetails from "./additionalDetails"
import Signature from "./signature"
import CaptureSelfie from "./captureSelfie"
import KYCComplete from "./KYCComplete"
import PANCard from "./PANCard"
import BusinessAdditionalDetails from "./businessAdditionalDetails"
import { useDispatch, useSelector } from "react-redux"
import KycProgressBar from "./kycProgressBar"
import { useLazyGetKycDataQuery } from "store/api/kyc/kyc"
import toast from "react-hot-toast"
import { setLoginUserData } from "store/slices/userSlice"
import KycFinalStep from "./kycFinalStep"
import AuthorisedSignatory from "./authorisedSignatory"
import KycAuthorityLetter from "./authorityLetter"
import KycFinalStepBusiness from "./KycFinalStepBusiness"
import { useNavigate } from "react-router-dom"
import MasterAgreement from "./agreementDetails"
import LoaderComponent from "components/loader"
import KYCInfo from "./KYCInfo"

const KYC = () => {
  const { user, userType } = useSelector((state) => state.user)
  const [currentStep, setCurrentStep] = useState("")
  const [kycData, setKycData] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [getResult, { isFetching }] = useLazyGetKycDataQuery()

  useEffect(() => {
    if (user) {
      // const currentStepKey = "ID_VERIFICATION"
      const currentStepKey = user.kyc_status
      setCurrentStep(currentStepKey)

      const currentStatus = user.status
      if (["APPROVED", "REJECTED"].includes(currentStatus)) {
        navigate("/")
      }
      if (["QUERY_RAISED"].includes(currentStatus)) {
        navigate("/resolve-query")
      }
    }
  }, [user])

  useEffect(() => {
    getKycData()
  }, [])

  const getKycData = async () => {
    try {
      const { success, message, data } = await getResult().unwrap()
      if (success) {
        setKycData(data)
        dispatch(
          setLoginUserData({
            user: {
              ...user,
              status: data.status,
              kyc_status: data.kyc_status,
              name: data.name,
              avatar_ur: data.avatar_url,
            },
          })
        )
      }
    } catch (error) {
      // toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid pb-6">
        <div className="mb-3 mb-md-5">
          <CardTitle className="mb-4 pt-4">Complete your KYC</CardTitle>
          <KycProgressBar kycData={kycData} />
        </div>
        {isFetching && <LoaderComponent />}
        {kycData && (
          <div
            className={`pb-md-5 ${kycData?.kyc_status !== "FINAL_STEP" ? "container-wrapper" : ""
              }`}
          >
            {/* {currentStep === "PHONE_VERIFICATION" && ( */}
            <KYCInfo kycData={kycData} />
            {/* )} */}
            {currentStep === "PHONE_VERIFICATION" && (
              <PhoneVerification kycData={kycData} />
            )}
            {currentStep === "ID_VERIFICATION" &&
              user.entity_type === "INDIVIDUAL" && (
                <IDVerification kycData={kycData} />
              )}
            {["BANK_VERIFICATION", "BANK_DETAILS"].includes(currentStep) && (
              <BankDetails currentStep={currentStep} kycData={kycData} />
            )}
            {currentStep === "ADDITIONAL_DETAILS" && (
              <AdditionalDetails kycData={kycData} />
            )}
            {currentStep === "BUSINESS_ADDITIONAL_DETAILS" && (
              <BusinessAdditionalDetails kycData={kycData} />
            )}
            {/* {currentStep === "SIGNATURE" && <Signature kycData={kycData} />} */}
            {currentStep === "PHOTO" && <CaptureSelfie kycData={kycData} />}

            {["PAN_GST", "GST_DETAILS", "GST_WAIVER"].includes(currentStep) && (
              <PANCard kycData={kycData} currentStep={currentStep} />
            )}
            {["ID_VERIFICATION", "AUTHORISED_SIGNATORY"].includes(
              currentStep
            ) &&
              user.entity_type === "COMPANY" && (
                <AuthorisedSignatory kycData={kycData} />
              )}
            {currentStep === "AUTHORITY_LETTER" && (
              <KycAuthorityLetter kycData={kycData} />
            )}
            {currentStep === "AGREEMENT_DETAILS" && (
              <MasterAgreement currentStep={currentStep} kycData={kycData} />
            )}

            {currentStep === "FINAL_STEP" &&
              user.entity_type === "INDIVIDUAL" && (
                <KycFinalStep kycData={kycData} />
              )}
            {currentStep === "FINAL_STEP" && user.entity_type === "COMPANY" && (
              <KycFinalStepBusiness kycData={kycData} />
            )}
            {currentStep === "SUBMITTED" && <KYCComplete />}
          </div>
        )}
      </div>
    </div>
  )
}

export default KYC
